import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { TransactionHistoryService } from '../../_services/transaction/transaction-history.service';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { ErrorHandler } from '@angular/core';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';

export class CustomModalContext extends BSModalContext {
  orderdid: string;
}
@Component({
  selector: 'app-get-receipt',
  templateUrl: './get-receipt.component.html',
  styleUrls: ['./get-receipt.component.css'],
  providers: [utilityService]
})
export class GetReceiptComponent implements OnInit, ModalComponent<CustomModalContext>, ErrorHandler {
  orderID: string;
  receiptType: string;
  constructor(
    private router: Router,
    private transHistory: TransactionHistoryService,
    public utilserv: utilityService,
    public dialog: DialogRef<CustomModalContext>,
    private alertService: AlertService,
    public translate: TranslateService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.orderID = this.dialog.context.orderdid;
  }
  handleError(error) {
    // send the error to the server
  }
  ngOnInit() {
    this.receiptType = 'EMAIL';
  }
  getreceipt() {
    this.utilserv.busy = this.transHistory.getorderreceiptservice(this.orderID, this.receiptType).subscribe(
      data => {
        try {
          if (data.StatusCode == enumStatusCodeList.SUCCESS && this.receiptType === 'PDF') {
            const base64str = data.OrderReceipt;
            // decode base64 string, remove space for IE compatibility
            const binary = atob(base64str.replace(/\s/g, ''));
            // get binary length
            const len = binary.length;
            // create ArrayBuffer with binary length
            const buffer = new ArrayBuffer(len);
            // create 8-bit Array
            const view = new Uint8Array(buffer);
            // save unicode of binary data into 8-bit Array
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i);
            }
            // create the blob object with content-type "application/pdf"
            const blob = new Blob([view], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
          } else if (data.StatusCode == enumStatusCodeList.SUCCESS && this.receiptType == 'EMAIL') {
            //Need to Place Alert

            this.alertService.openErrorAlert(this.translate.instant('Common_lblThankyou'), this.translate.instant('EmailReceiptSuccessPopup_desc'));
          } else if (data.StatusCode == -10000) {
            this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
            return;
          } else {
            //Need to Place Alert
            this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), data.StatusMessage);
          }
          this.dialog.close();
        } catch (ex) {
          console.log('Unable to get receipt from server' + ex);
          this.closePopup();
        }
      },
      error => {
        console.log('Unable to get receipt from server');
        this.closePopup();
      }
    );
  }

  closePopup() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/transaction-history/get-receipt/get-receipt.component.ts